<template>
    <div class="login-page">
        <div class="close" @click="loginClose">
            <i class="icon-close"></i>
        </div>
        <div class="login-page-box">
            <div class="header">
                <p>输入手机号码，查看顺丰通用券信息</p>
            </div>
            <section>
                <div class="mobile-wrap">
                    <p class="str">手机号</p>
                    <input ref="mobileInput" v-model="mobile" type="tel" maxlength="11" @input="isRegression" />
                </div>
                <div class="code-group">
                    <pwd-line ref="codeLine" @getPwd="getCode"></pwd-line>
                    <button class="valid-btn" :class="{ disabled: validBtnDisable }" @click="sendCode">{{ validBtnText }}</button>
                </div>
                <div class="login-btn-wrap">
                    <button type="button" class="primary-btn big" @click="toConponstList">确定</button>
                </div>
            </section>
            <!--腾讯验证码-->
            <tencent-captcha ref="tencentCaptcha"></tencent-captcha>
            <popup-toast v-show="showPopup" res="popupToast" title="无法发送" @close="showPopup = false">
                <p class="popup-p">该号码今天接收验证短信已达上限</p>
            </popup-toast>
        </div>
    </div>
</template>

<script>
import popupToast from '@/components/common/popup'
import Validation from '@/components/validation/validation'
import tencentCaptcha from '@/components/validation/tencent-captcha'
import { mobileReg } from '@/util/regs'
import ajax from '@/api/ajax'
import PwdLine from '@/components/pwdLine/pwd-line'
import { mapMutations } from 'vuex'

export default {
    components: {
        // eslint-disable-next-line vue/no-unused-components
        'v-validation': Validation,
        'pwd-line': PwdLine,
        tencentCaptcha,
        popupToast
    },
    props: {
        // 是否隐藏头部
        noHead: {
            type: String,
            default: 'true'
        }
    },
    data() {
        return {
            mobile: '', // 手机号码
            messageCode: '', // 验证码
            validationShow: false, // 显示图形验证码
            validBtnDisable: false, // 发送验证码按钮是否可用 false为可用
            count: '', // 验证码倒计时
            showPopup: false // 短信超出上限提示
        }
    },
    computed: {
        // 发送验证码按钮文案
        validBtnText() {
            if (this.count) {
                return `重发验证码${this.count}s`
            } else {
                return '获取验证码'
            }
        },
        // 校验中国大陆手机号码
        isMobileValid() {
            return mobileReg.test(this.trimMobile)
        },
        // 手机号码去空格
        trimMobile() {
            return this.mobile.replace(new RegExp(' ', 'g'), '')
        }
    },
    created() {
        this.setShowHeader(this.noHead !== 'true')
    },
    methods: {
        ...mapMutations({ setShowHeader: 'setShowHeader' }),
        // 点击发送验证码按钮
        sendCode() {
            if (this.trimMobile.length === 11) {
                if (!this.validBtnDisable) {
                    this.isMobileValid ? this.showTencentCaptcha(this.sendPhoneMsg) : this.$toast('手机号码不正确')
                }
            }
        },
        // 获取输入框中的验证码
        getCode(code) {
            this.messageCode = code
        },
        // 去列表
        toConponstList() {
            if (this.isMobileValid) {
                if (this.messageCode.length == 6 && this.validBtnDisable && this.isMobileValid) {
                    this.getCouponsData()
                } else {
                    this.$toast('验证码错误')
                }
            } else {
                this.$toast('手机号码不正确')
            }
        },
        // 登录
        getCouponsData() {
            const params = {
                customerTel: this.trimMobile, // 手机号
                couponType: 1, // 优惠卷类型
                status: 0 // 优惠卷状态
            }
            const headers = {
                'SMS-Verification-App': 'coupon',
                'SMS-Verification-Code': this.messageCode,
                'SMS-Verification-Mobile': this.trimMobile
            }
            ajax.getCoupons({ params, headers })
                .then(res => {
                    const { data, status } = res
                    if (status === 200) {
                        if (data.code === 111) {
                            this.$toast('验证码错误')
                        } else if (data.code === 0) {
                            this.$router.push({ path: 'couponslist' })
                            sessionStorage.setItem('customerTel', params.customerTel) // 保存当前手机号和验证码
                            sessionStorage.setItem('yzCode', headers['SMS-Verification-Code'])
                        }
                    }
                })
                .catch(res => {
                    this.$toast('网络错误')
                })
        },
        // 更新手机号 清空验证码
        isRegression() {
            if (this.trimMobile.length < 11) {
                this.mobile = this.trimMobile
                this.messageCode = ''
            }
        },

        // 验证码可发送倒计时
        getCodeReset: function () {
            const TIME_COUNT = 60
            if (!this.timer) {
                this.count = TIME_COUNT
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--
                    } else {
                        clearInterval(this.timer)
                        this.timer = null
                        this.validBtnDisable = false
                    }
                }, 1000)
            }
        },

        // 图形验证码成功回调
        getCodeSuccess(msg) {
            this.validBtnDisable = true
            this.getCodeReset()
        },

        // 图形验证码错误回调
        getCodeError(msg) {
            this.$toast(msg)
        },

        // 调用腾讯验证码
        showTencentCaptcha(callback) {
            this.$refs.tencentCaptcha.getCaptcha(callback)
        },

        // 发送手机短信
        sendPhoneMsg(retJson, isNew = true) {
            const headers = {
                'X-TC-TICKET': retJson.ticket,
                // 旧：CaptchaCheck 新：DescribeCaptchaResult
                'X-TC-VERSION': isNew ? 'DescribeCaptchaResult' : 'CaptchaCheck'
            }
            if (isNew) {
                headers['X-TC-RANDSTR'] = retJson.randstr
            }
            ajax.tencentNotification({
                params: {
                    mobile: this.trimMobile,
                    app: 'coupon',
                    area: ''
                },
                headers
            })
                .then(res => {
                    const data = res.data
                    if (!data || data.code !== 0) {
                        let errorMsg = ''
                        if (data.code == 410) {
                            this.showPopup = true
                        } else if (data.code == 400) {
                            errorMsg = '手机号错误'
                        } else {
                            errorMsg = data.message || '验证失败'
                        }
                        if (errorMsg) {
                            return this.$toast(errorMsg)
                        }
                    } else {
                        this.getCodeSuccess()
                    }
                })
                .catch(res => {
                    const errorMsg = '验证失败'
                    return this.$toast(errorMsg)
                })
        },
        loginClose() {
            window.location.href = '/mobile/cn/sc/'
        }
    },
    watch: {
        mobile() {
            if (this.mobile.length === 11) {
                this.mobile = this.mobile.replace(new RegExp(`([0-9]{${4},})`, 'g'), x =>
                    x
                        .split('')
                        .reverse()
                        .map((item, index) => (index > 0 && index % 4 === 0 ? `${item} ` : item))
                        .reverse()
                        .join('')
                )
                // 将光标移到最后一位
                setTimeout(() => {
                    this.$refs.mobileInput.setSelectionRange(13, 13)
                }, 5)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.mobile-wrap {
    margin-bottom: 80px;
    .str {
        color: #999;
        font-size: 22px;
        line-height: 30px;
    }
}
.mobile-wrap input {
    border-bottom: 0.03rem solid #ccc;
}
.next-step.disabled {
    background-color: #999999;
}
.login-page {
    overflow: hidden;
    .close {
        width: 100%;
        height: 0.88rem;
        .icon-close {
            display: block;
            position: relative;
            width: 48px;
            height: 48px;
            background: url('../../assets/images/coupons/clear_24px2x.png') center no-repeat;
            background-size: cover;
            top: 0.2rem;
            left: 0.42rem;
        }
    }
}
.login-page-box {
    padding: 10px 64px;
}
.header {
    position: relative;
    margin: 0.6rem 0;
    p {
        color: $gray;
        font-size: 0.28rem;
    }
}
.icon-wrapper {
    position: absolute;
    width: 96px;
    height: 96px;
    top: 0;
    left: 0;
}
.form-group {
    margin-bottom: 50px;
}
input[type='checkbox'] {
    width: 25px;
    height: 25px;
    position: relative;
    top: 2px;
}
.sms-verification input {
    width: 47%;
    margin-right: 3%;
}
.sms-verification button {
    width: 50%;
    position: relative;
    bottom: 2px;
    min-width: auto;
}
.code-group {
    position: relative;
}
.valid-btn {
    position: absolute;
    top: 0;
    right: 10px;
    background: none;
    border: none;
    font-size: 28px;
}
.login-checked {
    width: 0.3rem;
    height: 0.3rem;
    border: 0.02rem solid #dc1e32;
    background-color: #f2f2f2;
    position: relative;
    top: -0.03rem;
    left: -0.06rem;
    display: inline-block;
}
.next-step {
    display: block;
    background-color: #dc1e32;
    border-radius: 50px;
    color: white;
    float: right;
    width: 250px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: none;
    position: relative;
}
.arrow:before {
    content: '';
    display: block;
    position: absolute;
    width: 30px;
    height: 10px;
    border-top: 3px solid #fff;
    background: transparent;
    z-index: 9;
    transform: rotate(45deg);
    transform-origin: 2px 5px;
}
.arrow:after {
    content: '';
    display: block;
    position: absolute;
    width: 13px;
    height: 13px;
    border-left: 3px solid #fff;
    border-top: 3px solid #fff;
    background: transparent;
    z-index: -1;
}
.arrow {
    display: block;
    position: absolute;
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
    right: 40px;
    top: 48px;
}
.express-protocol {
    text-align: center;
    padding-top: 100px;
}
.login-checked {
    vertical-align: middle;
}

.login-checked.cur:before {
    content: '';
    width: 8px;
    height: 3px;
    transform: rotate(45deg);
    background-color: #dc1e32;
    position: absolute;
    display: block;
    top: 16px;
    left: 4px;
}
.login-checked.cur:after {
    content: '';
    width: 18px;
    height: 3px;
    transform: rotate(-45deg);
    background-color: #dc1e32;
    position: absolute;
    display: block;
    top: 13px;
    left: 6px;
}
.agree {
    color: rgb(220, 30, 50);
}
.agree .black {
    color: #333;
}
.login-btn-wrap {
    text-align: center;
    position: fixed;
    margin-top: 1.6rem;
    left: 0;
    width: 100%;
}
.primary-btn {
    border-radius: 0.5rem;
    width: 6.22rem;
}
.popup-p {
    font-size: 0.26rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/coupons/coupons-login.vue